import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule} from '@angular/common/http';

import { VendorModule } from '../core/vendor.module';
import { NgxMaskModule } from 'ngx-mask';

import { CoreModule } from '../core/core.module';
import { SecurityService } from '../security/security.service';
import { LoguedGuardService } from '../security/logued-guard.service';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SecurityModule } from '../security/security.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { AcuerdoComponent } from './acuerdo.component';
import { AcuerdoListComponent } from './acuerdo-list/acuerdo-list.component';
import { AcuerdoDetailsComponent } from './acuerdo-details/acuerdo-details.component';
import { AcuerdoAddEditComponent } from './acuerdo-add-edit/acuerdo-add-edit.component';
import { AcuerdoResolver } from './acuerdo.resolver';
import { AcuerdoFilterComponent } from './acuerdo-filter.component';
import { AcuerdoTableComponent } from './acuerdo-table/acuerdo-table.component';
import { AcuerdoProductoComponent } from './acuerdo-producto/acuerdo-producto.component';
import { AcuerdoLogoViewerComponent } from './acuerdo-logo-viewer/acuerdo-logo-viewer.component';
import { AcuerdoUserMontoMaxComponent } from './acuerdo-user-monto-max/acuerdo-user-monto-max.component';
import { VerPedidosComponent } from './ver-pedidos/ver-pedidos.component';
import { VerProductosPedidosComponent } from './ver-productos-pedidos/ver-productos-pedidos.component';
import { ChangeEjecutivoCuentaComponent } from './change-ejecutivo-cuenta/change-ejecutivo-cuenta.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    NgxMaskModule,
  ],
  declarations: [
    AcuerdoComponent,
    AcuerdoLogoViewerComponent,
    AcuerdoFilterComponent,
    AcuerdoProductoComponent,
    AcuerdoTableComponent,
    AcuerdoListComponent,
    AcuerdoDetailsComponent,
    AcuerdoAddEditComponent,
    AcuerdoUserMontoMaxComponent,
    VerPedidosComponent,
    VerProductosPedidosComponent,
    ChangeEjecutivoCuentaComponent,
  ],
  exports: [
    AcuerdoComponent,
    AcuerdoListComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    AcuerdoResolver
  ]
})
export class AcuerdoModule { }



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo.module.ts